import {Component, input} from '@angular/core';

@Component({
  selector: 'information-modal',
  imports: [],
  templateUrl: './information-modal.html',
  styleUrl: './information-modal.scss',
})
export class InformationModal {
  public textModal = input<string>('');
  public closeModal = input<() => void>();
}
